<template>
  <div class="page final extrainfo">
    <main>
      <div class="citybg"></div>

      <levensweg-header icon="?"></levensweg-header>
      <header class="header--final">
        <div class="headercont">
          <h2 class="titleslide--final">Bij&shy;komende <br/>info</h2>
          <p class="bodyslide--final">
            Hieronder kan je heel wat extra informatie vinden die je op weg
            helpt in je levensweg.
          </p>
        </div>
        <div class="babylyingcontainer lessspace">
          <img
            src="./../assets/img/introbeeld.svg"
            class="introbeeld hidden-sm visible-md"
          />
        </div>
      </header>
      <section class="infosection inhoudstabel" >
        <p class="articlebody">
          
        <ul class="opsomminginhoud">
          <li>
             <router-link to="/extrainfo#eicelleninvriezen" @click.native="goto('eicelleninvriezen')" >Eicellen invriezen? Misschien.</router-link>
          </li>
          <li>
           <router-link to="/extrainfo#houdbaarheidsdatum" @click.native="goto('houdbaarheidsdatum')" >Eicellen en zaadcellen hebben een houdbaarheidsdatum.</router-link>
          </li>
          <li>
            <router-link to="/extrainfo#nietzeker" @click.native="goto('nietzeker')" >Ik ben niet zeker of ik kinderen wil.</router-link>
          </li>
          <li>
            <router-link to="/extrainfo#willenkind" @click.native="goto('willenkind')" >Wij willen binnenkort graag een kind.</router-link>
          </li>
          <li>
            <router-link to="/extrainfo#luktnietmeteen" @click.native="goto('luktnietmeteen')" >Wij proberen zwanger te worden, maar het lukt niet meteen.</router-link>
          </li>
          <li>
            <router-link to="/extrainfo#vruchtbaarheidbeschermen" @click.native="goto('vruchtbaarheidbeschermen')" >Wat kan ik doen om mijn vruchtbaarheid te beschermen?</router-link>
          </li>

        </ul>
        </p>
      </section>

      <section ref="eicelleninvriezen" class="infosection" id="eicelleninvriezen">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Eicellen invriezen? Misschien.</h3>
            <p class="sectionintro">
              Een groeiend aantal koppels ondervindt vandaag problemen om hun gewenste familiegrootte te realiseren. 
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
                <h4 class="articletitle">
                </h4>
                <p class="articlebody">
                  Misschien droomde je altijd van een groot gezin, maar diende de ideale partner waarmee je een gezin wilt stichten zich nog niet aan? Of je voelt je er echt nog niet klaar voor? Misschien kan je eens nadenken over het invriezen van eicellen? Het kan voor sommige vrouwen een oplossing zijn, hoewel het een <strong>dure procedure</strong> betreft (€1.500 tot €3.000 per cyclus) en <strong>de kansen op een succesvolle zwangerschap</strong> matig zijn (30 tot 40% kans op slagen als er 10 eicellen beschikbaar zijn). Belangrijk is wel om jouw eicellen in te vriezen <strong>voor je 35ste</strong> om de kansen op een zwangerschap zo optimaal mogelijk te houden. Hoe jonger je bent bij deze procedure (en dus hoe jonger jouw eicellen zijn), hoe meer kans op succes.
                </p>
              </article>
          </div>
        </div>
      </section>
       <section ref="houdbaarheidsdatum" class="infosection" id="houdbaarheidsdatum">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Eicellen en zaadcellen hebben een houdbaarheidsdatum</h3>
            <p class="sectionintro">
              Wist je dat 25 jaar biologisch de meest geschikte leeftijd is voor vrouwen om kinderen te krijgen? Op 30-jarige leeftijd is de vruchtbaarheid bij vrouwen al aanzienlijk afgenomen. Dit is nochtans de leeftijd waarop de meeste vrouwen aan kinderen beginnen in Vlaanderen. 
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
               <h4 class="articletitle">
                </h4>
                <p class="articlebody">
                  In tegenstelling tot bij mannen, worden er tijdens het leven van een vrouw geen nieuwe voortplantingscellen aangemaakt. Bij de geboorte zijn er dus een <strong>maximaal aantal eicellen</strong> en deze nemen gedurende de jaren in stijgende mate af. Op 40-jarige leeftijd is het aantal eicellen al sterk afgenomen (meer dan 90%) en verminderen ze eveneens in <strong>kwaliteit</strong>. Daardoor is het op deze leeftijd moeilijker om zwanger te worden en lopen oudere moeders <strong>een hoger risico</strong> op een miskraam of een kind met het syndroom van Down (of andere afwijkingen). 
                  <br/><br/>
                  Er bestaat nog wat misverstand over de zogenaamde AMH – test. Bij deze test wordt anti-Mülleriaans hormoon (AMH) opgespoord in het bloed, waarbij de waarde iets kan zeggen over de reserve eicellen die een vrouw nog heeft. Mogelijks maakt de uitslag van zo’n test jou nodeloos ongerust of zorgt de uitslag er daarentegen voor dat je de kinderwens nog enkele jaren gaat uitstellen, terwijl leeftijd net een veel belangrijkere bepalende factor is voor jouw vruchtbaarheid. Bij vrouwen met onvervulde kinderwens die een vruchtbaarheidsbehandeling ondergaan, is deze test wel degelijk nuttig, maar de test kan niet voorspellen of je verminderd vruchtbaar bent. Niet meteen nuttig dus om zomaar deze test te laten doen.
                  <br/><br/>
                  Mannen maken wel steeds nieuwe voortplantingscellen aan en kunnen tot op latere leeftijd kinderen krijgen, mits hun partner jonger is. De leeftijd van de partner van de man zal dus een belangrijke bepalende factor zijn om kinderen te kunnen krijgen. Een aantal nieuwe studies hebben echter ook wel een effect gevonden van de <strong>leeftijd van de man</strong> op de kwaliteit van de zaadcellen. Zo kan het bijvoorbeeld langer duren om zwanger te worden en is er een hogere kans op miskraam bij een oudere vader. 
                  <br/><br/>
                  Hoewel <strong>medisch begeleide voortplanting</strong> (zoals IVF) heel veel koppels met vruchtbaarheidsproblemen aan een kind kan helpen, is deze techniek <strong>niet 100% effectief</strong>. Ook hier is de leeftijd van de vrouw een sterk bepalende factor om al dan niet zwanger te worden. Vrouwen jonger dan 35 hebben ongeveer 30% kans op een succesvolle zwangerschap bij de eerste poging. Op de <strong>leeftijd</strong> van 40 is dat nog slechts 10%. De kansen op een succesvolle zwangerschap na de leeftijd van 45 is bijna nihil. 
                </p>
               
              </article>
          </div>
        </div>
      </section>

       <section ref="nietzeker" class="infosection" id="nietzeker">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Ik ben niet zeker of ik kinderen wil.</h3>
            <p class="sectionintro">
              Sommige personen hebben een heel duidelijk toekomstbeeld, anderen leven liever van dag tot dag. Het is niet voor iedereen duidelijk in hoeverre het hebben van kinderen deel uitmaakt van ‘de ideale toekomst’ of niet. 
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
                <h4 class="articletitle">
                </h4>
                <p class="articlebody">
                  Het is helemaal niet nodig om jouw toekomst in detail uit te stippelen, maar probeer even stil te staan (eventueel samen met jouw partner) bij <strong>wat jij belangrijk vindt</strong> in het leven. Horen kinderen daarbij? Hoe denk jij over kinderen? Wat wil jouw partner volgens jou?
Waarom wil je kinderen of waarom wil je er geen? Wat doet jou twijfelen? Wie of wat heb je nodig om een beslissing te kunnen nemen? Wat zegt jouw <strong>twijfel</strong> over wat je belangrijk vindt? Hoe zie je je leven met of zonder kinderen? Hoe zie je jezelf als ouder? Hoe zou het zijn als jij of je partner plots zwanger is? Wat zou dit voor jou betekenen? Hoe voorkom je ongepland zwanger te worden, zolang je (nog) geen kinderen wil? 
<br/><br/>Uit onderzoek blijkt dat het gemiddelde kinderloze koppel <strong>gelukkiger</strong> is dan een koppel met kinderen. Zeker als dit een bewuste keuze is. Dat is zeker iets om bij stil te staan als je twijfelt.<br/><br/>Wil je de kansen om later kinderen te kunnen krijgen toch <strong>optimaliseren</strong>? Probeer dan nu al het volgende:<ul class="opsomming"><li>Bescherm jezelf tegen seksueel overdraagbare aandoeningen</li><li>Hanteer een gezonde leefstijl en streef een normaal gewicht na.</li><li>Wacht niet te lang. De vruchtbaarheid van vrouwen begint te dalen na 30 jaar. Op 35-jarige leeftijd ben je als vrouw maar half zo vruchtbaar als toen je 25 was.</li></ul>

                </p>
              </article>
          </div>
        </div>
      </section>
      <section ref="willenkind" class="infosection" id="willenkind">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Wij willen binnenkort graag een kind. </h3>
            
          </header>
            <div class="articleblocks">
              <article >
                <p class="articlebody">
                  Tips rond gezond zwanger worden vind je op de volgende websites:
                  <ul class="opsomming">
                    <li>
                      <a href="https://www.gezondzwangerworden.be">www.gezondzwangerworden.be</a>
                    </li>
                    <li>
                      <a href="https://www.kindengezin.be">www.kindengezin.be</a>
                    </li>
                  </ul>
                  Naast leeftijd is een gezonde leefstijl  en gezond gewicht voor beide partners belangrijk om de kans op een zwangerschap te verhogen en de gezondheid van de baby te optimaliseren. Meer informatie rond de impact van leefstijl op de vruchtbaarheid vind je <a href="https://www.deverdwaaldeooievaar.be/vruchtbaarheidproblemen/levensstijl">hier</a> en <a href="https://www.gezondzwangerworden.be/zwanger-worden/leefstijlfactoren-die-de-vruchtbaarheid-be%C3%AFnvloeden">hier</a>.
                </p>
              </article>
          </div>
        </div>
      </section>
      <section ref="luktnietmeteen" class="infosection" id="luktnietmeteen">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Wij proberen zwanger te worden, maar het lukt niet meteen.</h3>
            <p class="sectionintro">
              Meestal weet je van andere mensen niet meteen hoe lang het duurde voor men zwanger werd. Het lukt zeker niet bij iedereen de eerste maand. 
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
                <h4 class="articletitle">
               
                </h4>
                <p class="articlebody">
                  Ben je jonger dan 35? Wacht dan gerust een jaartje af voor je hulp zoekt. Als je ouder bent dan 35, valt er wat minder tijd te verliezen en kun je na 6 maanden proberen al eens een <strong>arts</strong> raadplegen voor jouw kinderwens. <br/><br/>
                  Heeft de vrouwelijke partner niet (ongeveer) maandelijks haar maandstonden? Maak dan ook best onmiddellijk een afspraak met een arts. Het kan best zwaar zijn als je een kindje wil, maar het lukt niet meteen. <strong>Wachten op een kind</strong> en vruchtbaarheidsbehandelingen kunnen veel <strong>stress</strong> en druk op de relatie met zich meebrengen. Bespreek ook dit met jouw arts. Veel mensen raadplegen een psycholoog als ze te maken krijgen met een onvervulde kinderwens.
<br/><br/>De informatie op deze sites kunnen jou mogelijk interesseren: <ul class="opsomming">
  <li>
    <a href="https://www.kindengezin.be/kinderwens/vruchtbaarheid/">https://www.kindengezin.be</a>
  </li>
  <li>
    <a href="https://www.deverdwaaldeooievaar.be/medische-begeleiding/medische-begeleiding/fertiliteitscentra-binnenland">https://www.deverdwaaldeooievaar.be</a>
  </li>
</ul>

Heb je <strong>een homoseksuele relatie</strong>? Bespreek jouw eventuele kinderwens met jouw huisarts of een arts in een centrum voor reproductieve geneeskunde. <br/><br/>Als je <strong>adoptie of pleegzorg</strong> overweegt, vind je hier meer info:
<ul class="opsomming">
  <li><a href="https://www.pleegzorgvlaanderen.be/">https://www.pleegzorgvlaanderen.be/</a></li>
<li>
  <a href="https://www.kindengezin.be/adoptie/ik-wil-adopteren/">https://www.kindengezin.be/adoptie/ik-wil-adopteren/ </a>
</li></ul>



                </p>
              </article>
          </div>
        </div>
      </section>

      <section ref="vruchtbaarheidbeschermen" class="infosection" id="vruchtbaarheidbeschermen">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Wat kan ik doen om mijn vruchtbaarheid te beschermen?</h3>
            <p class="sectionintro">
              Het zal nu wel al duidelijk zijn: niet te lang wachten met kinderen krijgen is heel belangrijk om de kansen op een zwangerschap te vergroten. 
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
                <h4 class="articletitle">
                </h4>
                <p class="articlebody">
                  Dat is vooral belangrijk voor vrouwen, maar ook bij mannen gaat de spermakwaliteit er op achteruit met de leeftijd. 
<br/><br/>Verder is het een cliché, maar <strong>gezond leven</strong> bevordert ook jouw vruchtbaarheid. Het is aangetoond dat roken, drinken, overgewicht, … de vruchtbaarheid negatief beïnvloedt (ook bij mannen). <br/><br/>Wist je dat blootstelling aan schadelijke omgevingsinvloeden eveneens de vruchtbaarheid kan aantasten? Dergelijke schadelijke stoffen vind je in veel producten terug, bijvoorbeeld in cosmetica, textiel en plastic. Daarom is het aangewezen om deze producten te wassen voor je ze gebruikt. Meer informatie vind je op: 
<ul class="opsomming">
  <li>
    <a href="https://gezondzwangerworden.be/zwanger-worden/leefstijlfactoren-die-de-vruchtbaarheid-be%C3%AFnvloeden">http://www.gezondzwangerworden.be</a>
  </li>
  <li>
    <a href="http://testjevruchtbaarheid.be">http://testjevruchtbaarheid.be</a>
  </li>
  <li>
    <a href="http://allesoverseks.be">http://allesoverseks.be</a>
  </li>
</ul>

                </p>
              </article>
          </div>
        </div>
      </section>


     

      <levensweg-footer class="footer" />
    </main>
  </div>
</template>

<script>
import Footer from "./../components/Footer";
import Header from "./../components/Header";

export default {
  components: {
    "levensweg-footer": Footer,
    "levensweg-header": Header,
  },
  mounted(){
    let section =this.$router.currentRoute.hash.replace("#", "");
    this.goto(section);

  },
  methods: {

    goto: function(refName) {
      var element = this.$refs[refName];
      
      if(element){
        var top = element.offsetTop;
        window.scrollTo(0, top);
      }else{
        window.scrollTo(0,0);
      }
    }
  }
  
};
</script>

<style>

.lessspace{
  margin-top:3rem;
}

.inhoudstabel{
  border-left: 1px solid var(--orange);
}

.opsomminginhoud{
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 2rem;
}
.opsomminginhoud li {
  margin-bottom:1rem;
}


.extrainfo a:link, .extrainfo a:visited,.extrainfo a:link:active, .extrainfo a:visited:active{
color: var(--blue);
}

.extrainfo .opsomming {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 3rem;
  list-style-type: disc;
}
.extrainfo .articlebody strong {
  font-weight: bold;
}

.extrainfo .infosection {
 /*margin-top:5rem;*/
 margin-bottom: 7rem;
}
.extrainfo .articletitle {
  -webkit-column-span: all;
  column-span: all;
  margin-top: 0.5rem;
}
.specialcols {
  -webkit-column-count: 1;
  -moz-column-count: 1;
  column-count: 1;
}

.footer {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
  margin-bottom: 4rem;
}
.rightblok {
  display: flex;
  flex-direction: column;

  margin-top: 8rem;
  margin-bottom: 6.2rem;
  margin-left: -1.8rem;
  margin-right: -1.8rem;
}
.parentsaside {
  align-self: center;
}
.rightblock__line {
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_path.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 231px;
  height: 368px;
  z-index: -1;
  margin-top: -5.5rem;
}

.rightblok:after {
  content: "";
  position: absolute;
  z-index: -2;
  background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 100%;
  height: 368px;
  margin-top: -3rem;
}

.ivf {
  width: 342px;
  height: 324px;
}



.ornamentline {
  background-image: url("../assets/img/line.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 254.4px;
  height: 496px;
  position: absolute;
  z-index: -2;
}
.citybg {
  background-image: url("../assets/img/city.svg");
  background-repeat: no-repeat;
  background-position: -150px 82px;
  background-size: auto 364px;
  width: 100%;
  height: 100%;
  z-index: -2;
  position: absolute;
}

.header--final {
  display: flex;
  flex-direction: column;
}

.infosection {
  display: flex;
  flex-direction: column;
}

.articleblocks {
  display: flex;
  flex-direction: column;
}

.infosection,
.testimonialsection {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
}

.sectiontitle {
  font-family: Montserrat;
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 2rem;
  color: var(--orange);
}

.sectionintro {
  font-family: "Playfair Display";
  font-size: 2rem;
  color: var(--titleslidecolor);
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
}

.articletitle {
  font-family: "Playfair Display";
  font-size: 1.6rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--titleslidecolor);
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.articletitle.second {
  margin-top: 3rem;
}

.articlebody {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--articlebodycolor);
  
}
.articlebody.noheading {
  margin-top: 3rem;
}
.titleslide--final {
  font-family: "Playfair Display";
  font-size: 6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: var(--titleslidecolor);

  /*animation: fadeandmove 0.8s ease-out 0s;*/
  animation-name: movetitleslide1, fade;
  animation-timing-function: ease-out, ease-in;
  animation-duration: 0.5s, 1s;
  word-break: word-break;
  hyphens: manual;
}
.bodyslide--final {
  font-family: Montserrat;
  font-weight: 300;
  font-size: 1.3rem;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--bodyslidecolor);
  margin: 3.5rem 0 0 0;
  width: 26.6rem;
  animation-name: fade;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
  animation-delay: 0.8s;
  animation-fill-mode: backwards;
}
.btn--final a {
  margin-left: 0;
}

.header--final {
  margin: 14.4rem 14.6% 0 14.6%;
}

/* tablet */
@media only screen and (min-width: 768px) {

  .specialcols {
  -webkit-column-count: 2;
  -moz-column-count: 2;
  column-count: 2;
}
  .page {
    position: relative;
  }

  .babylyingcontainer {
    margin-left: 0;
    margin-bottom: 6rem;
    margin-right: 2rem;
    text-align: right;
  }
  .babylying {
    width: 80%;
    max-width: 449px;
    height: 80%;
    max-height: 374px;
  }
  .ivf {
    width: 308px;
    height: auto;
  }
  .infosection {
    flex-direction: row;
    align-items: flex-end;
  }
  .extrainfo .infosection::after {
    background: none;
  }
  .header--final {
    flex-direction: row-reverse;
    margin-left: 1.8rem;
    margin-right: 1.8rem;
    align-items: flex-end;
    margin-bottom: 8rem;
  }
  .header--final div {
    flex: 50%;
  }
  .sectionintro {
    width: 75%;
  }
  .extrainfo .sectionintro {
    width: 100%;
  }
  .rightblok:after {
    position: relative;

    margin-top: -100%;
  }
}

@media only screen and (min-width: 992px) {
  .infosection {
    align-items: flex-start;
  }

  .citybg {
    background-size: contain;
    background-position-x: 0px;
  }

  .infosection.plan {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .articleblocks {
    flex-direction: row;
  }
  .sectionintro {
    width: 59.1rem;
  }

  .ornamentline {
    background-image: url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%; /*496px;*/
    position: absolute;
    z-index: -2;
  }
}

@media only screen and (min-width: 1200px) {
  .ornamentline {
    width: 100%;
    height: 496px;
  }

  .titleslide--final {
    font-size: 8rem;
    line-height: 1.06;
    width: 428px;
    max-width: 428px;
  }
  .babylyingcontainer {
    margin-right: 123px;
  }
  .header--final {
    margin-top: 81px;
  }

  .citybg {
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .bodyslide--final {
    font-size: 1.5rem;
    width: 34.2rem;
    line-height: 1.47;
  }
  .sectiontitle {
    font-size: 1.3rem;
    margin-bottom: 2.2rem;
  }
  .sectionintro {
    font-size: 3rem;
  }
  .articletitle {
    font-size: 2rem;
    margin-top: 7.5rem;
  }
  .articletitle.second {
    margin-top: 7.5rem;
  }
  .articlebody {
    font-size: 1.5rem;
  }
  .plan .articlebody {
    width: 40.9rem;
  }
  .page.final {
    height: auto;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }
  .btn--final {
    margin-top: 4rem;
  }
}
</style>
